












/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
// change to business classes you need.
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ListItemDTO, UserLoginDetails } from "../../Generated/ParticaAPI";
import { ButtonConfig } from "../../Models/Buttons";
import { ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import ParticaAccountBase from "../Base/ParticaAccountBase.vue";
import { IUserService } from "../../BusinessServices/user";
import { ParticaListContent, ParticaListLineContent } from "../../Models/ParticaListModel";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";

@Component(
	{
		name: "ParticaUsers",
		components: { ParticaList2Line, ParticaCard, ParticaView }
	})
export default class ParticaUsers extends ParticaAccountBase {
	// create or inject services
	private userService: IUserService;
	@Prop() private id: number;
	private listdata: ParticaListContent = new ParticaListContent();
	private buttons: ButtonConfig[] = [ // init our menu for the list.
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Account Users";
		this.userService = this.particaServices.getUserService();
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			const users: UserLoginDetails[] = await this.userService.getUsers(this.id);
			users.forEach(user => {
				const line: ParticaListLineContent = { subtitle: user.provider, title: user.email, image: "" } as ParticaListLineContent;
				this.listdata.lines.push(line);
			});
			await this.getAccountNav(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}

}
